import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from "moment";
import { LocalStorage } from 'ngx-store';
import { Observable, throwError } from 'rxjs';
import { catchError, pluck, retry, shareReplay } from 'rxjs/operators';
import { RunRoute, RunType } from '../model/dispatch.model';
import { ServiceType } from '../model/fleet.model';
import { BreachRequest } from '../pages/breach/breach';

@Injectable({
  providedIn: 'root'
})
export class LocalDispatchService {
  @LocalStorage() url;
  // Http Headers
  httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json'
      })
  }

  constructor(public http: HttpClient) { }

  getRunsLocal(statusFilter = '', dateFilter = '', start = '', end = ''): Observable<any> {
    var param = '';
    if (statusFilter) {
        param = '/' + statusFilter;
        if (dateFilter) {
            param = param + '/' + dateFilter;
            if (dateFilter == 'range') {
                if (moment(end).isSameOrAfter(moment(start))) {
                    param = param + '/' + start + '/' + end; 
                }
            } 
        }

    }
    return this.http.get<any>(this.url.rest+ '/tms/getRunsLocal' + param, this.httpOptions)
    .pipe(
        retry(1),
        catchError(this.handleError)
    );
  }

  //for local-manifestv2 testing
  getRunsLocalv2(statusFilter, dateFilter, start, end, offset, limit): Observable<any> {
    var param = '';
    let status = statusFilter?statusFilter:0;
    let date = dateFilter?dateFilter:0;
    let from = start?start:0;
    let to = end?end:0;

    param = '/'+status+'/'+date+'/'+from+'/'+to+'/'+offset+'/'+limit;
    console.log('param ', param);

    // return this.http.get<any>('http://127.0.0.1:8000/tms/getRunsLocalv2' + param, this.httpOptions)
    return this.http.get<any>(this.url.rest+ '/tms/getRunsLocalv2' + param, this.httpOptions)
    .pipe(
        // retry(1),
        catchError(this.handleError)
    );
  }

  getTasksWithoutRunLocal(): Observable<any> {
    return this.http.get<any>(this.url.rest + '/tms/getTasksWithoutRunLocal', this.httpOptions)
        .pipe(
            retry(1),
            catchError(this.handleError)
        );
  }

  getTasksWithoutRunLocalv2(): Observable<any> {
    return this.http.get<any>(this.url.rest + '/tms/getTasksWithoutRunLocalv2', this.httpOptions)
        .pipe(
            // retry(1),
            catchError(this.handleError)
        );
  }

    createRunsLocal(runs): Observable<any> {
      return this.http.post<any>(this.url.rest + '/tms/createRunsLocal', runs, this.httpOptions)
          .pipe(
              // retry(1),
              catchError(this.handleError)
          )
  }

  updateRunsLocal(info:any): Observable<any> {
      let temp = {
          'activities': info.activities,
          'driver_id': info.driver_id, 
          'run_id': info.run_id,
          'created_by': info.admin_id,
          'trigger': 'local dispatch'
      }
      return this.http.post<any>(this.url.rest + '/tms/updateRunsLocal', temp, this.httpOptions)
          .pipe(
              // retry(1),
              catchError(this.handleError)
          )
  }

  removeConnote(connotes, runID:number, admin_id:number): Observable<any> {
      let arr = {'connotes': connotes, 'run_id': runID, 'admin_id': admin_id}
      return this.http.post<any>(this.url.rest + '/tms/undoUpdate', arr, this.httpOptions)
          .pipe(
              // retry(1),
              catchError(this.handleError)
          )
  }

  getLocalDrivers(): Observable<any> {
    return this.http.get<any>(this.url.rest + '/tms/getLocalDispatchDrivers', this.httpOptions)
        .pipe(
            retry(1),
            catchError(this.handleError)
        );
}

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
    } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
  
  /**
   * Checks if connote service type is applicable in run/equipment service type
   * 
   * @param connote must have 'service_type_id' property
   * @param service equipment type of run
   * @returns array of connote with higher equipment load than service type parameter
   */
  checkAllowedServiceType(connote, service){
    let higherConnotes = connote.filter((x) =>{
        const st = x.service_type_id
        if(st != null && st != service){
          if(service == 1){ //lowest
            return x;
          } else if(service == 2 || service == 8){
            if (st > 2) return x;
          } else if(service == 9){
            if(st > 2 || st != 8) return x;
          } else if (service == 4){ //Semi
            if (st != 3) return x;
          } else if(service == 6){
            if(st != 4 || st != 12 || st != 13) return x;
          } else if(service == 3 || service == 5) {
            return x;
          }
        }
      });
    return higherConnotes
  }
}
